export default __webpack_public_path__ + "static/media/movie.a821cb99.svg";